import React, { useState } from "react";
import { ImagenOptimizada } from "shared-components/Components/Image/_new_web";
import { PropComponentMode } from "../../../../Components/Property/PropertyInterfaces";
import { usePropertyCover } from "../../PropertyCover/hook";
import { PropertyModalGallery } from "./PropertyModalGallery/web";
import "./styles.less";

export const PropertyModalPhotos = ({
	images = [],
	mode = "auto",
	isProject = false,
	img,
	listing,
	isDisabledProperty=false
}: {
	images: Image[];
	mode: PropComponentMode;
	isProject: boolean;
	img: string;
	listing: Listing
	isDisabledProperty?: boolean
}) => {
	const { data } = usePropertyCover(mode, images, isProject);
	const [expand, setExpand] = useState<false | number>(false);	

	return (
		<>
			<div 
			className={`
				property-modal-photos 
				${data.images.length % 3 == 2 ? "last-big-mobile" : "" }
				${data.images.length <= 2 ? 
					"show-all" : 
					data.images.length % 5 == 3 || data.images.length % 5 == 1
						? "last-big-desktop"
						: data.images.length % 5 == 4
							? "last-two-half"
							: ""
				}
			`}>
				{data.images.map((item, i)=>{
					return (
						<div
							className="pmp-image"
							key={"pmp_image_" + i }
							onClick={() => setExpand(i)}>
							<ImagenOptimizada src={item.image} width={500} />
						</div>
					)
				})}
			</div>
			{!isDisabledProperty && 
				<PropertyModalGallery
					show={typeof expand != "boolean"}
					images={images}
					img={img}
					initialIndex={typeof expand != "boolean" ? expand : 0}
					onClose={() => setExpand(false)}
					mode={mode}
					listing={listing}
				/>
			}
		</>
	);
};
